export default {
	field: 'productClass.catClass',
	name: 'CATCLASS #',
	width: '150px',
}
